import { Link } from "react-router-dom";
import { Mail, Car } from "lucide-react";

const Footer = () => (
  <footer
    className="border-t border-white/5 bg-[#070708] mt-20"
    data-testid="site-footer"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-lg bg-amber-500/15 border border-amber-500/40 flex items-center justify-center">
            <Car className="w-4 h-4 text-amber-400" />
          </span>
          <span className="font-display text-base font-extrabold uppercase tracking-wider">
            GETEASY <span className="text-amber-400">CAR</span>
          </span>
        </div>
        <p className="mt-4 text-sm text-slate-400 max-w-xs leading-relaxed">
          Vehicle Sourcing · Purchase · Repair Coordination · Delivery.
        </p>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-amber-400 mb-4">
          / Contact
        </div>
        <a
          href="mailto:geteasycar26@gmail.com"
          data-testid="footer-contact-email"
          className="inline-flex items-center gap-2 text-sm text-slate-200 hover:text-amber-400 transition"
        >
          <Mail className="w-4 h-4 text-amber-400" />
          geteasycar26@gmail.com
        </a>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-amber-400 mb-4">
          / Legal
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <Link
            to="/policies"
            data-testid="footer-policies-link"
            className="text-slate-300 hover:text-amber-400 transition"
          >
            Customer Policies & Terms of Service
          </Link>
          <Link
            to="/policies#privacy"
            className="text-slate-300 hover:text-amber-400 transition"
          >
            Privacy
          </Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center text-[11px] uppercase tracking-widest text-slate-500">
      © {new Date().getFullYear()} GETEASY CAR · Find it. Fix it. Drive it.
    </div>
  </footer>
);

export default Footer;
